import { z } from 'zod';

export const authTypes = z.union([z.literal('email'), z.literal('phone')]);

export type AuthType = z.infer<typeof authTypes>;

export const loginQueryParams = z.object({
  type: authTypes.optional(),
  deleteProfile: z.string().optional(),
});
